import { NodeTypes } from "../../../components/ProcessEditor/types";
import type { Node } from "../../../components/ProcessEditor/utils/createNodes";
import type {
  FieldLayoutData,
  StepLayoutData,
  SwimlaneLayoutData
} from "../../../types/layout.types";
import { StudioNodeType, type NodeDetails } from "../useStudioAPI.types";

/** Checks if node is a valid node type for incontext chat */
const checkValidInteractableStudioNode = (selectedNode?: Node) =>
  !!selectedNode &&
  [NodeTypes.STEPGROUP, NodeTypes.STEP, NodeTypes.FIELD].includes(
    selectedNode.type
  );

//TODO: add type for position
/** Gets position of the selected node */
export const getReactFlowNodePositon = (selectedNode?: Node | null) => {
  if (!selectedNode || !checkValidInteractableStudioNode(selectedNode))
    return null;
  const selectedDOMNode = document.querySelector(
    `[data-id=${selectedNode.id}]`
  );
  const selectedNodeViewportPosition: DOMRect | undefined =
    selectedDOMNode?.getBoundingClientRect();
  return selectedNodeViewportPosition
    ? {
        x: selectedNodeViewportPosition.x,
        y: selectedNodeViewportPosition.y,
        width: selectedNodeViewportPosition.width,
        height: selectedNodeViewportPosition.height
      }
    : null;
};

const getReactFlowNodeTypeToNodeType = (type: NodeTypes) => {
  switch (type) {
    case NodeTypes.STEPGROUP:
      return StudioNodeType.SWIMLANE;
    case NodeTypes.STEP:
      return StudioNodeType.STEP;
    case NodeTypes.FIELD:
      return StudioNodeType.FIELD;
    default:
      return undefined;
  }
};

export const getNodeDetailsFromReactFlowNode = (node: Node): NodeDetails => {
  return {
    type: getReactFlowNodeTypeToNodeType(node.type) as StudioNodeType,
    id: node.id,
    tag: node.tag as string,
    data:
      node.type === NodeTypes.STEPGROUP
        ? getStepgroupData(node.data.stepgroup)
        : node.type === NodeTypes.STEP
          ? getStepData(node.data.step)
          : node.data.field
  };
};

const getStepgroupData = (stepgroupData: SwimlaneLayoutData) => {
  return {
    ...stepgroupData,
    steps: stepgroupData.steps.map(getStepData)
  };
};

const getStepData = (stepData: StepLayoutData) => ({
  ...stepData,
  fields: stepData.fields.map((field: FieldLayoutData) => field.id)
});
